// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__fcp0T","subheader":"ReorderModal_subheader__23Nzx","listWrap":"ReorderModal_listWrap__21CHb"};